export const HEADER_HEIGHT_LARGE = "69px";
export const HEADER_HEIGHT_SMALL = "65px";
